import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IPricingApi } from "@/api/pricing";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { useToast } from "@/hooks/use-toast";
import { invalidatePricing } from "./invalidatePricing";

export const useImportMetaRates = () => {
  const pricingApi = useInjection<IPricingApi>(SERVICES_TYPES.PRICING);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ file, effectiveFrom }: { file: string; effectiveFrom: string }) =>
      pricingApi.importRates(file, effectiveFrom),
    onSuccess: (result) => {
      invalidatePricing(queryClient);
      toast({
        title: `Imported ${result.imported} rates`,
        description: result.skipped.length
          ? `${result.skipped.length} rows skipped — see the list below.`
          : undefined
      });
    },
    onError: (error) => {
      toast({ title: "Import failed", description: error.message, variant: "destructive" });
    }
  });
};
